// extracted by mini-css-extract-plugin
export default {"event__header":"event__header__s3vpC","event__header__avatar":"event__header__avatar__eJPZF","event__header__title":"event__header__title__ZSD4r","error":"error__wYz3O"};